import React from 'react'
import { useMemo } from 'react';
import useDidMountEffect from '../../../../../hooks/useDidMountEffect/useDidMountEffect'
import {Div} from "../../../../registroMaternidad/modales/components/Components";
import InputSelect from "../../../../../components/modalComponents/InputSelect";
import InputText from "../../../../../components/modalComponents/InputText";
import InputBool from '../../../../../components/modalComponents/InputBool';
import {TableBeneficiosToSolicitarSummary} from "../components/StyledComponents";
import {toast} from "react-toastify";
import AsyncSelectInputGET from "../../../../../components/Select/AsyncSelectInputGET";
import {getAlumnoMatriculadoAll} from "../../../../../consumers/backendApisUrls";

const ConfirmarBeneficios = ({
                                 sendCurrentStep,
                                 setSendCurrentStep,
                                 componentStep,
                                 KEYS,
                                 selectProps,
                                 SECTION_NAME,
                                 formValues,
                                 setFormValues,
                                 modalData,
                                 setModalData,
                                 getPayloadToSubmitItems
                             }) => {

    const msgValidacionCuotas = 'Debe indicar la cantidad de cuotas.';
    const msgValidacionAlumno = 'Debe ingresar el alumno matriculado.';
    const msgValidacionWhatsApp = 'Debe ingresar un número de WhatsApp de 9 dígitos.';
    useDidMountEffect(() => {
        if (sendCurrentStep?.step === componentStep && sendCurrentStep?.isSent) {
            handleSubmit();
        }
    }, [sendCurrentStep])

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();

        let errores = [];
        if(!formValues[KEYS.CuotasPago]){
            errores.push(msgValidacionCuotas);
        }
        if (modalData?.campanaBeneficioItemsToSolicitarResponse?.RequiereDataExterna &&
            !formValues.IdAlumnoMatriculado && formValues.IndicaAlumnoMatriculado) {
            errores.push(msgValidacionAlumno);
        }
        if (modalData?.campanaBeneficioItemsToSolicitarResponse?.SolicitarNumeroWhatsApp &&
            !/^\d{9}$/.test(formValues[KEYS.NumeroWhatsApp] ?? '')) {
            errores.push(msgValidacionWhatsApp);
        }

        if (errores.length > 0) {
            errores.forEach(err => toast.error(err));            
            return;
        }
        setSendCurrentStep(lastData => ({...lastData, isSent: false, isSaved: true}))
    }

    const handleWhatsAppChange = (e) => {
        const soloDigitos = (e.target.value ?? '').replace(/\D/g, '').slice(0, 9);
        setFormValues(prev => ({...prev, [KEYS.NumeroWhatsApp]: soloDigitos}));
    };

    const handleAlumnoChange = (selectedOption) => {
        console.log('handleAlumnoChange llamado con:', selectedOption);
        if (selectedOption) {
            setFormValues(prev => ({
                ...prev,
                IdAlumnoMatriculado: selectedOption.value,    
                NombreAlumnoMatriculado: selectedOption.label,
                DniAlumnoMatriculado: selectedOption.Dni
            }));
        } else {
            setFormValues(prev => ({
                ...prev,
                IdAlumnoMatriculado: null,
                NombreAlumnoMatriculado: '',
                DniAlumnoMatriculado:''
            }));
        }
    };

    const alumnoSeleccionado = useMemo(() => {
        if (!formValues.IdAlumnoMatriculado) return null;
        return {
            value: formValues.IdAlumnoMatriculado,
            label: formValues.NombreAlumnoMatriculado || "Alumno seleccionado"
        };
    }, [
        formValues.IdAlumnoMatriculado,
        formValues.NombreAlumnoMatriculado
    ]);
    
    const handleIndicaAlumnoChange = (e) => {
        const checked = e.target.checked;
        setFormValues(prev => ({
            ...prev,
            IndicaAlumnoMatriculado: checked,
            // Si desmarcan, limpiamos el alumno seleccionado
            ...( !checked && {
                IdAlumnoMatriculado: null,
                NombreAlumnoMatriculado: '',
                DniAlumnoMatriculado: ''
            })
        }));
    };

    return (
        <div>
            <div className="displayFlexWrap">
                <Div>
                    <InputSelect
                        label="Campaña"
                        {...selectProps(KEYS.idCampanaBeneficio)}
                        sectionName={SECTION_NAME}
                        isDisabled={true}
                        isRequired={false}
                    />
                </Div>
                {modalData?.initialDataResponse?.FechaActual &&
                    <Div>
                        <InputText
                            name="Fecha"
                            label="Fecha"
                            value={modalData?.initialDataResponse?.FechaActual}
                            placeholder=""
                            isDisabled
                        />

                    </Div>
                }

                {modalData?.initialDataResponse?.NombreEmpleado &&
                    <Div>
                        <InputText
                            name="NombreEmpleado"
                            label="Empleado"
                            value={modalData?.initialDataResponse?.NombreEmpleado}
                            placeholder=""
                            isDisabled
                        />
                    </Div>
                }

                {modalData?.initialDataResponse?.Sede &&
                    <Div>
                        <InputText
                            name="Sede"
                            label="Sede"
                            value={modalData?.initialDataResponse?.Sede}
                            placeholder=""
                            isDisabled
                        />
                    </Div>
                }

                {modalData?.campanaBeneficioItemsToSolicitarResponse?.CuotasMax &&
                    <>
                    <Div>
                        <InputSelect
                            label="Cuotas"
                            {...selectProps(KEYS.CuotasPago)}
                            name="CuotasPago"
                            isRequired={true}
                        />
                        {!formValues[KEYS.CuotasPago]  &&
                            <p className="ficha-form-input-validation-message">{msgValidacionCuotas}</p>
                        }
                    </Div>
                    <Div>
                        &nbsp;
                    </Div>
                    </>
                }
                
                {modalData?.campanaBeneficioItemsToSolicitarResponse?.RequiereDataExterna && (
                <>
                <Div>
                    <InputBool 
                        label="¿Mi compra es para un alumno matriculado en Innova Schools?" 
                        name="IndicaAlumnoMatriculado"
                        value={formValues.IndicaAlumnoMatriculado ?? false}                        
                        textInput="No / Sí" 
                        onChange={handleIndicaAlumnoChange}
                        direction="column"
                        isDisabled={false}
                        isRequired={false}                        
                        />
                </Div>
                <Div>
                    <div className="input-form-row ">
                        <label className="modal-label d-flex required">Alumno matriculado</label>
                        <div className='black-color highlight-input'>                                                 
                            <AsyncSelectInputGET                                 
                                api={getAlumnoMatriculadoAll} 
                                placeholder="Nombre y/o apellidos o DNI" 
                                handleSelectInputChange={handleAlumnoChange}
                                value={alumnoSeleccionado}    
                                valueKey="Value"
                                labelKey="Text"  
                                isDisabled={!formValues.IndicaAlumnoMatriculado}                                                    
                            />
                            
                            {formValues.IdAlumnoMatriculado && (
                                <div className="mt-2 text-muted small">
                                    <strong>{formValues.NombreAlumnoMatriculado}</strong>  
                                    <br />
                                    DNI: <strong>{formValues.DniAlumnoMatriculado || '—'}</strong>
                                </div>
                            )}

                            {/* Mensaje de validación si intenta avanzar sin seleccionar */}
                            {sendCurrentStep?.isSent && !formValues.IdAlumnoMatriculado && (
                                <p className="ficha-form-input-validation-message">
                                    {msgValidacionAlumno}
                                </p>
                            )}

                        </div>
                    </div>
                    
                </Div>
                </>
                )}

                {modalData?.campanaBeneficioItemsToSolicitarResponse?.SolicitarNumeroWhatsApp && (
                <Div>
                    <InputText
                        label="Número de WhatsApp"
                        name={KEYS.NumeroWhatsApp}
                        value={formValues[KEYS.NumeroWhatsApp] ?? ''}
                        onChange={handleWhatsAppChange}
                        sectionName={SECTION_NAME}
                        maxLength={9}
                        isRequired={true}
                        placeholder="Ingresar 9 dígitos"
                        direction="column"
                    />
                    {!/^\d{9}$/.test(formValues[KEYS.NumeroWhatsApp] ?? '') &&
                        <p className="ficha-form-input-validation-message">{msgValidacionWhatsApp}</p>
                    }
                </Div>
                )}

                <TableBeneficiosToSolicitarSummary>
                    <table>
                        <thead>
                        <tr>
                            <th>Descripción</th>
                            <th>Cantidad</th>
                            <th>Precio Unitario</th>
                            <th>Sub. Total</th>
                        </tr>
                        </thead>
                        <tbody>

                        {modalData?.currentItems?.filter(o => o.checked === true).map(o => (
                            <tr key={o.IdCampanaBeneficioItem}>
                                <td>{o?.Descripcion}</td>
                                <td>{o?.cantidad}</td>
                                <td>S/. {o?.MontoText}</td>
                                <td>S/. {(o?.cantidad * o?.MontoDecimal).toFixed(2)}</td>
                            </tr>
                        ))}

                        </tbody>
                        <tfoot>
                        <tr className="total-row">
                            <td colSpan="3">Total</td>
                            <td>S/. {modalData?.currentTotal?.toFixed(2)}</td>
                        </tr>
                        </tfoot>
                    </table>
                </TableBeneficiosToSolicitarSummary>
            </div>
        </div>
    )
}

export default ConfirmarBeneficios;